import React from "react";

export const GenericAppError = ({ text }) => {
  return <p className="App__error">{text}</p>;
};
